import { RetailerPromptSelect } from '~/components/common/retailer-prompt-select';
import { useCanChooseRetailerPrompt } from '~/hooks/useCanChooseRetailerPrompt';

interface RetailerPromptSectionProps {
  value: string;
  onChange: (retailer: string) => void;
  /** `data-testid` for the section wrapper. */
  testId?: string;
}

/**
 * The panel's retailer-prompt row, in the same bordered section style as its siblings. Renders
 * nothing (not even the border) for non-`@lily.ai` users, so their panel is unchanged.
 */
export function RetailerPromptSection({
  value,
  onChange,
  testId = 'retailer-prompt-section',
}: RetailerPromptSectionProps) {
  const canChoose = useCanChooseRetailerPrompt();
  if (!canChoose) return null;
  return (
    <div data-testid={testId} className="border-t px-6 py-5">
      <RetailerPromptSelect
        id="enrichment-run-retailer"
        layout="stacked"
        testId={`${testId}-select`}
        value={value}
        onChange={onChange}
      />
    </div>
  );
}
